<template>
  <transition name="fade">
    <div v-if="value">
      <!-- Overlay -->
      <div class="modal-overlay" @click.self="close"></div>

      <!-- Contenedor del modal -->
      <div class="modal-container">
        <!-- Botón de cierre -->
        <button class="modal-close" @click="close">×</button>

        <!-- Slot del encabezado (opcional) -->
        <div class="modal-header" v-if="$slots.header">
          <slot name="header"></slot>
        </div>

        <!-- Contenido principal -->
        <div class="modal-body">
          <slot></slot>
        </div>

        <!-- Slot del pie de página (opcional) -->
        <div class="modal-footer" v-if="$slots.footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "ModalInfo",
  props: {
    // Usamos el prop `value` para v-model
    value: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    close() {
      this.$emit("input", false);
    },
  },
};
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

/* Overlay semitransparente */
.modal-overlay {
  position: fixed;
  top: 0; left: 0;
  width: 100vw; height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

/* Caja del modal */
.modal-container {
  position: fixed;
  top: 50%; left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  color: #000;   
  border-radius: 8px;
  max-width: 90%;
  width: 400px;
  padding: 1.5rem;
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
  z-index: 1001;
}

/* Botón “×” */
.modal-close {
  position: absolute;
  top: 0.5rem; right: 0.5rem;
  background: none;
  border: none;
  font-size: 1.2rem;
  color: #000;  
  cursor: pointer;
}

/* Encabezado opcional */
.modal-header {
  margin-bottom: 1rem;
  font-weight: bold;
  font-size: 1.1rem;
}

/* Cuerpo */
.modal-body {
  margin-bottom: 1rem;
  color: #333;
}

/* Pie de página opcional */
.modal-footer {
  display: none !important;
}
</style>
